

import NotFound from './Components/Images/404-Error-Page.svg';

import './App.css';

export default function App() {
  return (
    <div className='flex h-[100vh] w-[100vw] justify-center items-center'>
      <img className='w-full h-full' src={NotFound} alt='not-found' />
    </div>
  );
}
